import { useReleases } from "@/routes/simulator/context/release";
import { useUpdateSimulator } from "@/api/useRelease";
import { OptionalFieldGroup } from "./FieldGroup";

export function UpdateSimulatorGoodFeedbackSeperation() {
  const { simulator, refetchSimulators } = useReleases();
  const { mutateAsync: updateSimulator } = useUpdateSimulator({
    simulatorId: simulator?.id ?? 0,
  });

  return (
    <OptionalFieldGroup
      label={"Use Isolated Training Data"}
      description={
        "Use only feedback and training data specific to this AI agent. When off, training is shared across all agents"
      }
      enabled={simulator?.seperateGoodFeedback ?? false}
      toggleEnabled={async (nextValue) => {
        if (simulator?.id) {
          await updateSimulator({
            name: simulator.name,
            seperateGoodFeedback: nextValue,
          });
          await refetchSimulators();
        }
      }}
    />
  );
}
